import React from 'react';
import { number, shape } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import {
  Col,
  Row,
  Button,
  Card,
  CardContent,
  CardTitle,
} from '@thd-olt-component-react/core-ui';
import {
  StorePod,
  StorePodName,
  StorePodAddress,
  StorePodHours,
  StorePodPhoneNumber,
  StorePodLink,
  StorePodMap,
} from '@thd-olt-component-react/store-pod';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

function onClickChangeStoreLink({ channel, storeId }) {
  window.scrollTo(0, 0);
  const myStoreMobileElement = document.getElementById('myStoreMobile');
  const myStoreOverlayElement = document.getElementById('myStore-overlay');

  if (channel === 'mobile') {
    myStoreMobileElement.dispatchEvent(new Event('touchend'));
  } else {
    document.dispatchEvent(new Event('launchLocDrawer'));
  }

  // Fallback if localization drawer failed to open. User redirected to store search pg.

  if (myStoreOverlayElement.classList.contains('u--hide')) {
    if (channel === 'mobile') {
      window.location.href = `/l/search/${storeId}/list/`;
    } else {
      window.location.href = `/l/search/${storeId}/full/`;
    }
  }
}

const StoreDetailsPropTypes = {
  renderWidths: shape({
    minWidthLarge: number,
  }),
};

const StoreDetailsDefaultProps = {
  renderWidths: {
    minWidthLarge: undefined,
  }
};

export function CustomRenderedStoreDetails({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,

  channel,
  isB2B,
  store,
}) {
  function StoreDetails({ renderWidths: { minWidthLarge } }) {
    const isCard = minWidthLarge < 5;

    const mapOptions = !isB2B
      ? { height: '238', width: '532', zoom: 10 }
      : { height: '238', width: '532', zoom: 10 };
    const { storeId } = store;

    return (
      <QueryProvider cacheKey="storeDetails">
        <Hydrator
          id="storeDetails-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          delay={HOMEPAGE_DELAY_STANDARD}
          placeholder={PLACEHOLDER}
        >
          <Card>
            <CardTitle
              className="card__title u-width-100"
              title="Your Store"
              action={{
                content: (
                  <Button
                    link
                    transparent
                    onClick={() => onClickChangeStoreLink({ channel, storeId })}
                  >
                    Change Store
                  </Button>
                ),
              }}
            />
            <CardContent className="u-width-100">
              <StorePod storeId={storeId} className="grid">
                <StorePodMap
                  className="store-map"
                  storeId={storeId}
                  mapOptions={mapOptions}
                />
                <div
                  className={`store-pod-details ${
                    !isCard ? 'store-details-half' : ''
                  }`}
                >
                  <StorePodName className="store-podname" markup="h3" />
                  <StorePodAddress displaySingleLine={isB2B} />
                  {!isB2B && (
                    <StorePodPhoneNumber
                      type="store"
                      colorOfNumber="alternate"
                      hideLabel
                    />
                  )}
                  <StorePodHours />
                  {isB2B && (
                    <Row className="store-number-b2b-container">
                      <Col
                        fallback="12"
                        xs="6"
                        sm="6"
                        md="6"
                        className="store-number-b2b"
                        nopadding
                      >
                        <StorePodPhoneNumber
                          type="tool"
                          boldLabel
                          displayMultiline
                          colorOfNumber="alternate"
                          showIcon
                        />
                      </Col>
                      <Col
                        fallback="12"
                        xs="6"
                        sm="6"
                        md="6"
                        className="store-number-b2b"
                        nopadding
                      >
                        <StorePodPhoneNumber
                          type="pro"
                          boldLabel
                          displayMultiline
                          colorOfNumber="alternate"
                          showIcon
                        />
                      </Col>
                    </Row>
                  )}
                </div>
              </StorePod>
            </CardContent>
            <CardContent className="u-width-100 u-flex-end">
              <StorePod storeId={storeId} className="u--paddingNone">
                <StorePodLink type="store" className="store-pod-link u__left" />
                <span className="footnote-separator u__left">&#124;</span>
                <StorePodLink
                  type="localAd"
                  className="store-pod-link u__left"
                />
              </StorePod>
            </CardContent>
          </Card>
        </Hydrator>
      </QueryProvider>
    );
  }

  StoreDetails.propTypes = StoreDetailsPropTypes;
  StoreDetails.defaultProps = StoreDetailsDefaultProps;

  return StoreDetails;
}
